import { Link } from 'react-router-dom'
import { Page } from '../components/Layout'

export default function Landing() {
  return (
    <Page>
      <section className="py-8">
        <p className="mb-3 text-sm font-medium uppercase tracking-wide text-pfa-coral">Atraso na entrega de imóvel</p>
        <h1 className="max-w-3xl text-4xl font-semibold leading-tight text-pfa-navy md:text-5xl">
          Sua construtora atrasou a entrega do imóvel?
        </h1>
        <p className="mt-4 max-w-2xl text-lg text-pfa-slate">
          Avalie seu caso de forma informativa e entenda seus direitos. Atendimento conduzido pela Paula Farias
          Advocacia, com análise individual pela nossa equipe de advogados especialistas em Direito Imobiliário.
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/triagem" className="btn-accent">
            Avaliar meu caso
          </Link>
          <Link to="/calculadora" className="btn-ghost">
            Estimativa rápida
          </Link>
        </div>
      </section>

      <section className="mt-10 grid gap-4 md:grid-cols-3">
        {[
          { t: '1. Triagem', d: 'Algumas perguntas guiadas para entender se há atraso além do prazo de tolerância contratual.' },
          { t: '2. Proposta transparente', d: 'Você recebe as condições com clareza — sem promessa de resultado.' },
          { t: '3. Acompanhamento', d: 'Contratação digital, envio de documentos e acompanhamento do andamento.' },
        ].map((c) => (
          <div key={c.t} className="card">
            <h3 className="font-semibold text-pfa-navy">{c.t}</h3>
            <p className="mt-2 text-sm text-pfa-slate">{c.d}</p>
          </div>
        ))}
      </section>

      <section className="mt-10 card">
        <h2 className="font-semibold text-pfa-navy">Quanto custa? (explicado de forma simples)</h2>
        <ul className="mt-4 space-y-3 text-sm text-pfa-slate">
          <li className="flex gap-3">
            <span className="font-semibold text-pfa-coral">1.</span>
            <span><strong className="text-pfa-navy">Para começar, você não paga nada.</strong> Sem mensalidade, sem taxa inicial.</span>
          </li>
          <li className="flex gap-3">
            <span className="font-semibold text-pfa-coral">2.</span>
            <span>
              A entrada só é cobrada <strong className="text-pfa-navy">se a Justiça mandar pausar as parcelas</strong> do
              seu imóvel — e, mesmo assim, só alguns dias depois disso acontecer.
            </span>
          </li>
          <li className="flex gap-3">
            <span className="font-semibold text-pfa-coral">3.</span>
            <span>
              No final, <strong className="text-pfa-navy">se você recuperar algum valor</strong>, uma parte combinada
              fica com o escritório. É o chamado honorário de êxito.
            </span>
          </li>
        </ul>
        <p className="mt-4 text-sm text-pfa-slate">
          Tudo é explicado com clareza, em valores exatos, <strong>antes</strong> de você assinar qualquer coisa.
        </p>
      </section>
    </Page>
  )
}
